import React, { useEffect, useState } from 'react';
import { Image } from 'antd';
import usePortalService from '../../services/PortalService';

type ImageDownloadableProps = {
    id: string
    type: string
    style?: object
    preview?: boolean
    onClick?: () => void
}

export default function ImageDownloadable(props: ImageDownloadableProps) {
    const {getImage} = usePortalService()
    const [src, setSrc] = useState('')

    useEffect(() => {
        if (props.id) {
            getImage(props.type, props.id)  
            .then(result => {
                setSrc(result)
            })
        }
    }, [])

    return (
        <Image src={src} style={props.style} preview={props.preview} onClick={props.onClick}/>
    )
}